
// GET Requests

export const LOCATIONS_FETCH = '/stores/locations';
export const TRANSFERS_FETCH = '/messages/transfers/fetch';
export const TRANSFERS_INCOMING_FETCH = '/messages/transfers/fetch/incoming';
export const TRANSFERS_OPEN_FETCH = '/messages/transfers/fetch/open';
export const TRANSFERS_CLOSED_FETCH = '/messages/transfers/fetch/closed';

export const TRANSFERS_EXPORT = '/messages/transfers/export';
export const TRANSFERS_CHECK_DIAMOND = '/diamonds/check';

export const USERS_DD_AUTH = '/users/ms/auth';
export const USERS_LOCAL_AUTH = '/users/local/auth';


// POST Requests

export const USERS_LOGIN = '/users/transfer/login';
export const USERS_FORGOT_PASSWORD = '/users/forgot-password';

export const TRANSFERS_APPROVE = '/messages/transfers/approve';
export const TRANSFERS_REJECT = '/messages/transfers/reject';
export const TRANSFERS_PENDING = '/messages/transfers/pending';
export const TRANSFERS_EDIT = '/messages/transfers/edit';
export const TRANSFERS_ADD = '/messages/transfers/create';
export const TRANSFERS_SHIP = '/messages/transfers/ship';
export const TRANSFERS_CANCEL = '/messages/transfers/cancel';
export const TRANSFERS_COUNT = '/messages/transfers/fetch/counts';

export const TRANSFERS_APPROVE_LOCAL = '/messages/transfers/local/approve';
export const TRANSFERS_REJECT_LOCAL = '/messages/transfers/local/reject';


//  Diamond API Requests

export const PRODUCT_DIAMOND_BY_ID = '/api/diamond/find_by_id';